import { formatCompactNumber } from '../number/compact';
import { formatCompactUsd } from './compact-usd';

/**
 * Money in the currency it is stated in, in the investor screens' style. A
 * dollar amount, and only one the caller has established as dollars
 * (`isDollar`), keeps the dollar sign ("$1.2M"). Anything else prints the
 * number followed by its unit as text ("1.2M EURC"), because a dollar sign
 * on a euro amount states a conversion nobody performed. The unit is never
 * read for a dollar claim: a token whose name happens to be "USD" is still
 * printed as "100 USD". With no unit known the bare number prints.
 */
export function formatCompactMoney(
  value: number,
  { isDollar, unit }: { isDollar: boolean; unit: string | null | undefined },
  { maximumFractionDigits = 2 }: { maximumFractionDigits?: number } = {}
): string {
  if (!Number.isFinite(value)) return '—';
  if (isDollar) return formatCompactUsd(value, { maximumFractionDigits });
  const amount = formatCompactNumber(value, { maximumFractionDigits });
  const label = unit?.trim();
  return label ? `${amount} ${label}` : amount;
}
